<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold ">
                <v-icon color="primary" class="mr-3" size="34">mdi-message-text-outline</v-icon>
                Contacto
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card outlined class="rounded-0">
                <v-card-title>
                    <div class="font-weight-bold primary--text text-h5">
                        DISTRITO
                        {{ descripcionDistrito }}
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row class="d-flex flex-row">
                        <v-col cols="12" md="12">
                            <div class="d-flex font-weight-regular black--text text-body-1 my-2 align-center">
                                <v-icon color="gray" class="mr-4">mdi-home-outline</v-icon>
                                {{ datosDistrito.direccion }}

                            </div>
                            <div class="d-flex font-weight-regular black--text text-body-1 my-2 align-center">
                                <v-icon color="gray" class="mr-4">mdi-phone-outline</v-icon>
                                {{ datosDistrito.telefono }}
                            </div>
                            <div class="d-flex font-weight-regular black--text text-body-1 my-2 align-center">
                                <v-icon color="gray" class="mr-4">mdi-clock-outline</v-icon>
                                Horarios de atención: {{ datosDistrito.horario }}
                            </div>
                            <div class="d-flex font-weight-regular black--text text-body-1 my-2 align-center">
                                <v-icon color="gray" class="mr-4">mdi-email-outline</v-icon>
                                {{ datosDistrito.email }}
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card flat class="mt-5 rounded-0">
                <v-card-title class="font-weight-bold primary--text">
                    Enviar mensaje
                </v-card-title>
                <ValidationObserver ref="obs" v-slot="{ invalid }">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field v-model="correo.subject" name="name" label="Asunto"
                                        :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required|email" v-slot="v">
                                    <v-text-field v-model="emailAfiliado" label="Responder a email"
                                        :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-textarea v-model="correo.message" label="Mensaje..." class="my-5" auto-grow
                                        outlined rows="10" row-height="10" :error-messages="v.errors[0]"></v-textarea>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-file-input v-model="files" accept=".jpg, .jpeg, .pdf" :show-size="1000" counter
                                    label="Adjuntar archivo/s" multiple>
                                    <template v-slot:selection="{ index, text }">
                                        <v-chip v-if="index < 2" color="primary darken-2" dark label small>
                                            {{ text }}
                                        </v-chip>
                                        <span class="text-overline grey--text text--darken-3 mx-2"
                                            v-else-if="index === 2">
                                            +{{ files.length - 2 }} Archivo(s)
                                        </span>
                                    </template>
                                </v-file-input>
                            </v-col>
                            <v-card-text class="d-flex flex-row justify-end px-0">
                                <v-btn color="primary" elevation="0" @click="sendEmail" :disabled="invalid" width="150"
                                    class="py-5">
                                    Enviar</v-btn>
                            </v-card-text>
                        </v-row>
                    </v-card-text>
                </ValidationObserver>
            </v-card>
        </v-card>
    </v-container>

</template>

<script>
import InputFiles from '@/components/inputs/InputFiles.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        InputFiles,
        ValidationObserver,
        ValidationProvider,
        SkeletonLoader
    },
    watch: {
        loading() {
            return (Object.keys(this.datosDistrito).length > 0)
        }
    },

    data() {
        return {
            obj: null,
            correo: {
                subject: '',
                message: ''
            },
            emailAfiliado: '',
            adjuntarArch: false,
            files: [],


        }
    },
    methods: {
        ...mapActions('mediosDeContacto', ['envioMailDistritoConArch', 'envioMailDistrito']),
        sendEmail() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    let obj = {
                        nroafi: this.nroafi,
                        message: this.correo.message,
                        subject: this.correo.subject,
                        //emailDistrito: this.datosDistrito.email,
                        emailAfi: this.emailAfiliado,
                        tipoComunicacion: 'distrito',
                        nombreApellido: this.nombreApellido
                    }
                    let keys = Object.keys(obj)

                    let formData = new FormData()
                    for (let i = 0; i < keys.length; i++) {
                        formData.append(keys[i], obj[keys[i]])
                    }
                    if (this.files.length !== 0) {
                        this.files.forEach((element, index) => {
                            formData.append(`archivo[${index}]`, element)
                        });
                        this.envioMailDistritoConArch(formData)
                    } else
                        this.envioMailDistrito(obj)
                    this.correo = {}
                }
            })
        },
        cagarArchivos() {
            this.file = ref
        },
        isEmpty(obj) {
            if (typeof obj == 'object' && obj !== null) {
                return Object.keys(obj).length == 0;
            } else false

        }
    },
    computed: {
        ...mapGetters('auth', ['user', 'nroafi', 'loadSkeleton', 'emailAuth']),
        ...mapGetters(['emailPrinc']),
        ...mapGetters('common', ['datosDistrito']),

        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`
        },
        descripcionDistrito() {
            return this.datosDistrito.desdistrito
        }
    },
    mounted() {
        // Pre-llenar el email de respuesta con el del afiliado.
        // El campo es editable por si el usuario quiere recibir respuesta en otra direccion.
        if (this.emailPrinc && this.emailPrinc.email) {
            this.emailAfiliado = this.emailPrinc.email
        } else if (this.user && this.user.email) {
            this.emailAfiliado = this.user.email
        } else if (this.emailAuth) {
            this.emailAfiliado = this.emailAuth
        }
    }
}
</script>